import { Injectable, Inject } from '@angular/core';
import { DwAttributeType, DwContextDefinition, DwMetaDataService, DwControlType, DwCustomContextBase, DwCustomContextDefinition, 
         DwExpressionAttribute, DwMetaDataServiceToken, DwQuery, DwMetaDataFormStateService, DwLookupInfo } from '@devwareapps/devware-cap';
import { StarRatingAvProjectsMetaData, SurveysMetaDataItemNames, StarRatingAvProjectsEntity, SurveysMetaDataLookups } from '../meta-data/surveys-meta-data.service';
import { map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

@DwCustomContextDefinition({
    keyName: AvStarRatingNspTechCountContextService.ContextName,
    display: 'Nsp Tech Count for WJID',
    isGlobal: false,
    parentItem: SurveysMetaDataItemNames.StarRatingAvProjects
})
@Injectable()
export class AvStarRatingNspTechCountContextService extends DwCustomContextBase {
    static ContextName: string = 'avStarRatingsNspTechCountContext';
    constructor(
        @Inject(DwMetaDataServiceToken) private dwMetaDataService: DwMetaDataService
    ){
        super();
    }

    count : number = 0;
    jobId: number = 0;
    setupContextDefinition(contextDef: DwContextDefinition) {
        contextDef.getCustomContextFunction = (resolvedContext => {
            const ratings : StarRatingAvProjectsEntity = resolvedContext?.data;
            return ratings == undefined || ratings?.Ethos_JobId == this.jobId
                    ? of({ TechCount : this.count || 0 }) 
                    : this.getLookup(ratings).pipe(map(items => {
                        this.count = items.length;
                        return { TechCount : this.count || 0 };
                    }));
        });
        contextDef.attributes = [];
        var hasPermissionAttr : DwExpressionAttribute = this.addProperty(contextDef.attributes, 
                                                                        'TechCount', 'Tech Count', 
                                                                         DwAttributeType.Integer, DwControlType.NumericTextBox);
    }

    getLookup(ratings : StarRatingAvProjectsEntity){
        this.jobId = ratings?.Ethos_JobId;
        return  this.jobId == undefined ? of([]) :
                this.dwMetaDataService.getLookup(SurveysMetaDataLookups.NSPInstallTechs, 
                                                [{ ParamName: 'JobId', ParamValue: this.jobId.toString() }]);
    }
}